/**
 * Lead Drop Form 2001 — CMS field configuration (inline placement).
 *
 * The inline card is pixel-identical to the popup, so the field list is the
 * shared one, imported rather than duplicated. The only difference is what is
 * absent: the auto-open triggers (delay / exit intent) are popup-only, since an
 * embedded form is always on screen and never opens itself.
 *
 * Like the popup config, every field is `isJsonField: true` and therefore lands
 * in `additional_fields` — see the note in leadDropPopup_2001.ts for why.
 *
 * This row is configured separately from the popup's (university_settings
 * section 2 vs section 1), exactly as lead form 2 works today, so an editor can
 * give the inline form different copy from the overlay.
 */

import { LEAD_DROP_2001_SHARED_FIELDS } from "../leadDropPopup/leadDropPopup_2001";

const DEFAULT_ROW = LEAD_DROP_2001_SHARED_FIELDS.reduce<
  Record<string, string | number | boolean>
>((acc, field) => {
  acc[field.fieldName] = field.defaultValue;
  return acc;
}, {});

export const LEAD_DROP_FORM_2001_CONSTANTS = {
  DEFAULT_ROW,
  LEAD_DROP_FORM_FIELDS_CONFIG: LEAD_DROP_2001_SHARED_FIELDS,
  METADATA_FIELDS: [],
};
